import { Component, OnInit, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../common/shared.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ToastrService } from "ngx-toastr";
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Http} from '@angular/http';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../header/topnav/topnav.service';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: March 20th 2018
 * 
 * Description: Component class for Online Services - /onlineservice
 **/
@Component({
  selector: 'gosg-onlineservice',
  templateUrl: './onlineservice.component.html',
  styleUrls: ['./onlineservice.component.css']
})
export class OnlineserviceComponent implements OnInit, AfterViewInit, OnDestroy {
  valByKeyword: any;

  dropdownOpt = [];
  onlyAgency: boolean = false;
  keyword: boolean = false;
  agencyUrl: any;

  lang:any;
  languageId:any;

  pageCount = 1;
  pageSize = 10;
  noPrevData = true;
  noNextData = false;
  seqNo = 0;
  seqPageNum = 0;
  seqPageSize = 0;
  showNoData = false;
  listAgency = [];
  datatblAgencyPage = [];
  dataAlpha = [];
  dataPage = null;
  inxlan = 0;
  public loading = false;
  chkOnline = false;
  chkDownload = false;
  isDocument;
  dataAgencyPage = null;
  valByAlpha;
  valByAgency;
  totalApps: any = 0;

  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private topnavservice: TopnavService,
    private http: Http,
    @Inject(APP_CONFIG) private config: AppConfig,

  ) {
    this.lang = translate.currentLang;
    // this.languageId = 2;
    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;

      if (myLang == 'en') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.languageId = 1;
          this.inxlan = 0;
          this.dropdownOpt = [
            {
              "id": 0,
              "value": "Show All"
            },{
              "id":1,
              "value":"By Agency"
            },
            {
              "id":2,
              "value": "By Keyword"
            }
          ];
        });

      }

      if (myLang == 'ms') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.languageId = 2;
          this.inxlan = 1;
          this.dropdownOpt = [
            {
              "id": 0,
              "value": "Lihat Semua"
            },{
              "id":1,
              "value":"Mengikut Agensi"
            },
            {
              "id":2,
              "value": "Mengikut Kata Kunci"
            }
          ];
        });
      }
      console.log({'topnavservice.flagLang': this.topnavservice.flagLang})

      if(this.topnavservice.flagLang){

        this.onlyAgency = false;
        this.loadAlpha(true);
        // this.selAllAgency(this.pageCount, this.pageSize);d
        // this.selAgency(this.pageCount, this.pageSize);
        this.reset();
      }

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title + this.translate.instant('home.breadcrumb.onlineservice');
          this.sharedService.setTitle(title);
        }); 
      },500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
      $('.mat-checkbox-label').css('font-family', this.fontType);
      $('.mat-button-wrapper').css('font-family', this.fontType);
      $('.mat-select-value-text span').css('font-family', this.fontType);
    });

  }

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }

    this.valByAlpha = "0";
    this.valByAgency = "0";

    if(this.languageId == 1) {
      this.dropdownOpt = [
        {
          "id": 0,
          "value": "Show All"
        },{
          "id":1,
          "value":"By Agency"
        },
        {
          "id":2,
          "value": "By Keyword"
        }
      ];
    } else {
      this.dropdownOpt = [
        {
          "id": 0,
          "value": "Lihat Semua"
        },{
          "id":1,
          "value":"Mengikut Agensi"
        },
        {
          "id":2,
          "value": "Mengikut Kata Kunci"
        }
      ];
    }
    this.pageSize = this.sharedService.defaultPageSize ;
    
    this.loadAlpha(true);
    this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
  }

  ngAfterViewInit() {
    
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.breadcrumb.onlineservice');
      this.sharedService.setTitleAndGtag(title);
    });
    
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();

  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
  }


  /**
   *
   * Select an options
   */

  selByOptions(event){
    this.sharedService.defaultPageSize = this.sharedService.pageSize[0].size;
    this.valByKeyword = "";
    this.chkDownload = false;
    this.pageCount = 1;
    this.pageSize = 10;
    this.chkOnline = false;
    this.valByAlpha = "0";
    if(event.value == 0){
      this.keyword = false;
      this.onlyAgency = false;
      this.loadAlpha(true);
      this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
    }else if(event.value == 1){
      this.keyword = false;
      this.onlyAgency = true;
      this.loadAlpha(false, true);
      this.selAgency(this.pageCount, this.pageSize);
    }else if(event.value == 2){
      this.keyword = true;
      this.onlyAgency = false;
      this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
    }
  }


  appTracking(refCode){
    const readUrl = `${this.config.urlPortal}agencyapplication/tracking?refCode=${refCode}&source=online-service`;
    const req = this.http.post(readUrl,'')
      .subscribe(
        res => {
          // console.log(res);
        },
        err => {
          console.log("Error occured");
        }
      );
  }



/**
 *
 * Load Alpha
 */


loadAlpha(onlineService?, agency?, isDocument?, keyword?){
  let dataUrl;


  if(agency && (typeof isDocument !== 'undefined')){
    dataUrl = 'agency/agencyid/app/alpha?document='+isDocument+'&language='+this.languageId;
  }else if(onlineService && (typeof isDocument !== 'undefined')){
    dataUrl = 'agency/application/search/onlineservices/alpha?document='+isDocument+'&language='+this.languageId;
  }else  if(onlineService){
    dataUrl = 'agency/application/search/onlineservices/alpha?language='+this.languageId;
  }else if(agency){
    dataUrl = 'agency/agencyid/app/alpha?language='+this.languageId;
  }else if(keyword){
    dataUrl = 'agency/application/search/onlineservices/alpha?keyword='+keyword+'&language='+this.languageId;
  }else if(keyword && (typeof isDocument !== 'undefined')){
    dataUrl = 'agency/application/search/onlineservices/alpha?keyword='+keyword+'&document='+isDocument+'&language='+this.languageId;
  }
  return this.http.get(this.config.urlPortal + dataUrl)
  .map(res => res.json())
  .subscribe(rData => {
    this.dataAlpha = rData.letters;
    
    // this.noNextData = true;
  })
}


/**
 *
 *
 * Checkbox selections
 *
 */

chkDocument(e, val) {
  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;
  this.sharedService.defaultPageSize = this.sharedService.pageSize[0].size;
  this.pageCount = 1;
  this.pageSize = 10;
  if(val == 1){
    this.chkDownload = false;
    this.chkOnline = true;
  }else if(val == 2){
    this.chkDownload = true;
    this.chkOnline = false;
  }

  if(!e.checked){
    this.chkDownload = undefined;
    this.chkOnline = undefined;
  }
  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(!e.checked){
        this.loadAlpha(true,false);
        this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal, this.languageId);
      }else{
        if(val === 1){
          this.loadAlpha(true,false, false);
          this.selAllAgency(this.pageCount, this.pageSize, false, undefined, alphaVal, this.languageId);
        }else if(val === 2){
          this.loadAlpha(true,false, true);
          this.selAllAgency(this.pageCount, this.pageSize, true, undefined, alphaVal, this.languageId);
        }
      }
    }else if(agencyVal == "1"){
      if(!e.checked){
        this.loadAlpha(false, true);
        this.selAgency(this.pageCount, this.pageSize, undefined, alphaVal);
      }else{
        if(val === 1){
          this.loadAlpha(false,true, false);
          this.selAgency(this.pageCount, this.pageSize, false, alphaVal);
        }else if(val === 2){
          this.loadAlpha(false,true, true);
          this.selAgency(this.pageCount, this.pageSize, true, alphaVal);
        }
      }
    }
  }else if(agencyVal == "0"){

    if(!e.checked){
      this.loadAlpha(true, false);
      this.selAllAgency(this.pageCount, this.pageSize, undefined, '', '', this.languageId);
    }else{
      if(val === 1){
        this.loadAlpha(true, false, false);
        this.selAllAgency(this.pageCount, this.pageSize, false, '', '', this.languageId);
      }else if(val === 2){
        this.loadAlpha(true, false, true);
        this.selAllAgency(this.pageCount, this.pageSize, true, '', '', this.languageId);
      }
    }

  }
  else if(agencyVal == "1"){
    if(!e.checked){
      this.loadAlpha(false, true);
      this.selAgency(this.pageCount, this.pageSize, undefined);
    }else{
      if(val === 1){
        this.loadAlpha(false, true, false);
        this.selAgency(this.pageCount, this.pageSize, false);
      }else if(val === 2){
        this.loadAlpha(false, true, true);
        this.selAgency(this.pageCount, this.pageSize, true);
      }
    }
  }
  else if(alphaVal !== "0"){
    if(!e.checked){
      this.loadAlpha();
      this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal, this.languageId);
    }else{
      if(val === 1){
        this.loadAlpha();
        this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal, this.languageId);
      }else if(val === 2){
        this.loadAlpha();
        this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal, this.languageId);
      }
    }
  }else if(agencyVal == "2"){
    if(this.valByKeyword){
      if(!e.checked){
        this.selAllAgency(this.pageCount, this.pageSize, undefined, this.valByKeyword, '', this.languageId);
      }else{
        if(val === 1){
          this.selAllAgency(this.pageCount, this.pageSize, false, this.valByKeyword, '', this.languageId);
        }else if(val === 2){
          this.selAllAgency(this.pageCount, this.pageSize, true, this.valByKeyword, '', this.languageId);
        }else{
          this.selAllAgency(this.pageCount, this.pageSize, undefined, this.valByKeyword, '', this.languageId);
        }
      }


    }else{
      if(!e.checked){
        this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
      }else{
        if(val === 1){
          this.selAllAgency(this.pageCount, this.pageSize, false, '', '', this.languageId);
        }else if(val === 2){
          this.selAllAgency(this.pageCount, this.pageSize, true, '', '', this.languageId);
        }else{
          this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
        }
      }
    }

  }
}

paginatorL1(page) {
  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;

  this.noPrevData = true;
  this.noNextData = false;
  this.pageCount = 1;

  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(this.chkOnline){
        this.selAllAgency(1, this.pageSize, false, undefined, alphaVal, this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(1, this.pageSize, true, undefined, alphaVal, this.languageId);
      }else{
        this.selAllAgency(1, this.pageSize, undefined, undefined, alphaVal, this.languageId);
      }
    }else if(agencyVal == "1"){
      if(this.chkOnline){
        this.selAgency(1, this.pageSize, false, alphaVal);
      }else if(this.chkDownload){
        this.selAgency(1, this.pageSize, true, alphaVal);
      }else{
        this.selAgency(1, this.pageSize, undefined, alphaVal);
      }
    }

  }else if(agencyVal == "0"){
    if(this.chkOnline){
      this.selAllAgency(1, this.pageSize, false, '', '',this.languageId);
    }else if(this.chkDownload){
      this.selAllAgency(1, this.pageSize, true, '', '',this.languageId);
    }else{
      this.selAllAgency(1, this.pageSize, undefined, '', '',this.languageId);
    }
  }else if(agencyVal == "1"){
    if(this.chkOnline){
      this.selAgency(1, this.pageSize, false);
    }else if(this.chkDownload){
      this.selAgency(1, this.pageSize, true);
    }else{
      this.selAgency(1, this.pageSize, undefined);
    }
  }else if(agencyVal == "2"){
    // if(this.valByKeyword){
      if(this.chkOnline){
        this.selAllAgency(1, this.pageSize, false, this.valByKeyword, '',this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(1, this.pageSize, true, this.valByKeyword, '',this.languageId);
      }else{
        this.selAllAgency(1, this.pageSize, undefined, this.valByKeyword, '',this.languageId);
      }

    // }

  } else{
    this.selAllAgency(1, this.pageSize, '', '', '',this.languageId);
  }
}



/**
 *
 *
 * Left and Right pagination navigation
 */

paginatorL(page) {
  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;

  this.noPrevData = page <= 2 ? true : false;
  this.noNextData = false;
  this.pageCount = page - 1;

  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(this.chkOnline){
        this.selAllAgency(this.pageCount, this.pageSize, false, undefined, alphaVal, this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(this.pageCount, this.pageSize, true, undefined, alphaVal, this.languageId);
      }else{
        this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal, this.languageId);
      }
    }else if(agencyVal == "1"){
      if(this.chkOnline){
        this.selAgency(this.pageCount, this.pageSize, false, alphaVal);
      }else if(this.chkDownload){
        this.selAgency(this.pageCount, this.pageSize, true, alphaVal);
      }else{
        this.selAgency(this.pageCount, this.pageSize, undefined, alphaVal);
      }
    }

  }else if(agencyVal == "0"){
    if(this.chkOnline){
      this.selAllAgency(this.pageCount, this.pageSize, false, '', '',this.languageId);
    }else if(this.chkDownload){
      this.selAllAgency(this.pageCount, this.pageSize, true, '', '',this.languageId);
    }else{
      this.selAllAgency(this.pageCount, this.pageSize, undefined, '', '',this.languageId);
    }
  }else if(agencyVal == "1"){
    if(this.chkOnline){
      this.selAgency(this.pageCount, this.pageSize, false);
    }else if(this.chkDownload){
      this.selAgency(this.pageCount, this.pageSize, true);
    }else{
      this.selAgency(this.pageCount, this.pageSize, undefined);
    }
  }else if(agencyVal == "2"){
    // if(this.valByKeyword){
      if(this.chkOnline){
        this.selAllAgency(this.pageCount, this.pageSize, false, this.valByKeyword, '',this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(this.pageCount, this.pageSize, true, this.valByKeyword, '',this.languageId);
      }else{
        this.selAllAgency(this.pageCount, this.pageSize, undefined, this.valByKeyword, '',this.languageId);
      }

    // }

  } else{
    this.selAllAgency(page - 1, this.pageSize, '', '', '',this.languageId);
  }
}




pageChange(event, totalPages) {
  window.scrollTo(0, 0);
  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;
  this.pageSize = event.value;
  this.pageCount = 1;
  this.noPrevData = true;

  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(this.chkOnline){
        this.selAllAgency(this.pageCount, this.pageSize, false, undefined, alphaVal,this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(this.pageCount, this.pageSize, true, undefined, alphaVal,this.languageId);
      }else{
        this.selAllAgency(this.pageCount, this.pageSize, undefined, undefined, alphaVal,this.languageId);
      }
    }else if(agencyVal == "1"){
      if(this.chkOnline){
        this.selAgency(this.pageCount, this.pageSize, false, alphaVal);
      }else if(this.chkDownload){
        this.selAgency(this.pageCount, this.pageSize, true, alphaVal);
      }else{
        this.selAgency(this.pageCount, this.pageSize, undefined, alphaVal);
      }
    }

  }else if(agencyVal == "0"){
    if(this.chkOnline){
      this.selAllAgency(this.pageCount, this.pageSize, false, '', '',this.languageId);
    }else if(this.chkDownload){
      this.selAllAgency(this.pageCount, this.pageSize, true, '', '',this.languageId);
    }else{
      this.selAllAgency(this.pageCount, this.pageSize, undefined, '', '',this.languageId);
    }
  }else if(agencyVal == "1"){
    if(this.chkOnline){
      this.selAgency(this.pageCount, this.pageSize, false);
    }else if(this.chkDownload){
      this.selAgency(this.pageCount, this.pageSize, true);
    }else{
      this.selAgency(this.pageCount, this.pageSize, undefined);
    }
  }else if(agencyVal == "2"){
    if(this.valByKeyword){
      if(this.chkOnline){
        this.selAllAgency(this.pageCount, this.pageSize, false, this.valByKeyword, '',this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(this.pageCount, this.pageSize, true, this.valByKeyword, '',this.languageId);
      }else{
        this.selAllAgency(this.pageCount, this.pageSize, undefined, this.valByKeyword, '',this.languageId);
      }

    }

  }else{
    this.selAllAgency(this.pageCount, this.pageSize, '', '', '',this.languageId);
  }

}



paginatorR(page, totalPages) {
  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;

  this.noPrevData = page >= 1 ? false : true;
  let pageInc: any;
  pageInc = page + 1;
  this.pageCount = pageInc;


  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(this.chkOnline){
        this.selAllAgency(pageInc, this.pageSize, false, undefined, alphaVal,this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(pageInc, this.pageSize, true, undefined, alphaVal,this.languageId);
      }else{
        this.selAllAgency(pageInc, this.pageSize, undefined, undefined, alphaVal,this.languageId);
      }
    }else if(agencyVal == "1"){
      if(this.chkOnline){
        this.selAgency(pageInc, this.pageSize, false, alphaVal);
      }else if(this.chkDownload){
        this.selAgency(pageInc, this.pageSize, true, alphaVal);
      }else{
        this.selAgency(pageInc, this.pageSize, undefined, alphaVal);
      }
    }

  }else if(agencyVal == "0"){
    if(this.chkOnline){
      this.selAllAgency(pageInc, this.pageSize, false, '', '', this.languageId);
    }else if(this.chkDownload){
      this.selAllAgency(pageInc, this.pageSize, true, '', '', this.languageId);
    }else{
      this.selAllAgency(pageInc, this.pageSize, undefined, '', '', this.languageId);
    }
  }else if(agencyVal == "1"){
    if(this.chkOnline){
      this.selAgency(pageInc, this.pageSize, false);
    }else if(this.chkDownload){
      this.selAgency(pageInc, this.pageSize, true);
    }else{
      this.selAgency(pageInc, this.pageSize, undefined);
    }
  }else if(agencyVal == "2"){
    // if(this.valByKeyword){
      if(this.chkOnline){
        this.selAllAgency(pageInc, this.pageSize, false, this.valByKeyword, '', this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(pageInc, this.pageSize, true, this.valByKeyword, '', this.languageId);
      }else{
        this.selAllAgency(pageInc, this.pageSize, undefined, this.valByKeyword, '', this.languageId);
      }

    // } 

  }else{
    this.selAllAgency(pageInc, this.pageSize, '', '', '', this.languageId);
  }

}

paginatorRL(page, totalPages) {

  let agencyVal = this.valByAgency;
  let alphaVal = this.valByAlpha;

  this.noPrevData = page >= 1 ? false : true;
  let pageInc: any;
  pageInc = page + 1;
  this.pageCount = pageInc = totalPages;
 


  if((agencyVal) && (alphaVal !== "0")){
    if(agencyVal == "0"){
      if(this.chkOnline){
        this.selAllAgency(totalPages, this.pageSize, false, undefined, alphaVal,this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(totalPages, this.pageSize, true, undefined, alphaVal,this.languageId);
      }else{
        this.selAllAgency(totalPages, this.pageSize, undefined, undefined, alphaVal,this.languageId);
      }
    }else if(agencyVal == "1"){
      if(this.chkOnline){
        this.selAgency(totalPages, this.pageSize, false, alphaVal);
      }else if(this.chkDownload){
        this.selAgency(totalPages, this.pageSize, true, alphaVal);
      }else{
        this.selAgency(totalPages, this.pageSize, undefined, alphaVal);
      }
    }

  }else if(agencyVal == "0"){
    if(this.chkOnline){
      this.selAllAgency(totalPages, this.pageSize, false, '', '', this.languageId);
    }else if(this.chkDownload){
      this.selAllAgency(totalPages, this.pageSize, true, '', '', this.languageId);
    }else{
      this.selAllAgency(totalPages, this.pageSize, undefined, '', '', this.languageId);
    }
  }else if(agencyVal == "1"){
    if(this.chkOnline){
      this.selAgency(totalPages, this.pageSize, false);
    }else if(this.chkDownload){
      this.selAgency(totalPages, this.pageSize, true);
    }else{
      this.selAgency(totalPages, this.pageSize, undefined);
    }
  }else if(agencyVal == "2"){
    // if(this.valByKeyword){
      if(this.chkOnline){
        this.selAllAgency(totalPages, this.pageSize, false, this.valByKeyword, '', this.languageId);
      }else if(this.chkDownload){
        this.selAllAgency(totalPages, this.pageSize, true, this.valByKeyword, '', this.languageId);
      }else{
        this.selAllAgency(totalPages, this.pageSize, undefined, this.valByKeyword, '', this.languageId);
      }

    // } 

  }else{
    this.selAllAgency(totalPages, this.pageSize, '', '', '', this.languageId);
  }

}


  getAgencyList() {
    return this.sharedService.readPortal('agency','1','999')
      .subscribe(rData => {
        this.listAgency = rData['list'];
      },
        Error => {
          this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
        });
  }

  selByAgency(eve) {
    this.pageCount = 1;
    this.noPrevData = true;
    this.chkDownload = false;
    this.chkOnline = false;
    this.valByAlpha = "0";
    if(eve.value == 1){
      this.onlyAgency = true;
      this.keyword = false;
      this.loadAlpha(true);
      this.selAgency(this.pageCount, this.pageSize);
    }else if(eve.value == 0){
      this.onlyAgency = false;
      this.keyword = false;
      this.loadAlpha(true);
      this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
    }else if(eve.value == 2){
      this.onlyAgency = false;
      this.keyword = true;
      
      // this.datatblAgency = [''];
    }else{
      this.onlyAgency = false;
      this.keyword = false;
      this.getDataSelByAgency(eve.value);
    }
  }

  getDataSelByAgency(val){
    this.loading = true;
      let dataUrl='agency/application/search?agencyId=' + val + '&page=' + this.pageCount + '&size=' + this.pageSize;
      return this.http.get(this.config.urlPortal + dataUrl + '&language=' + this.languageId)
        .map(res => res.json())
        .subscribe(rData => {
          this.sharedService.errorHandling(rData, (function () {
            this.dataPage = rData;
            if (rData['agencyApplicationList'].length > 0) {
              this.seqPageNum = this.dataPage.pageNumber;
              this.seqPageSize = this.dataPage.pageSize;
              this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
              this.datatblAgency = rData['agencyApplicationList'];
              this.showNoData = false;
            } else {
              this.showNoData = true;
              this.seqPageNum = this.dataPage.pageNumber;
              this.seqPageSize = this.dataPage.pageSize;
              this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
            }
          }).bind(this));
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
        });
  }

  selByAlpha(eve) {
    this.pageCount = 1;
    this.pageSize = 10;
    this.noPrevData = true;
    this.chkDownload = false;
    this.chkOnline = false;
    this.sharedService.defaultPageSize = this.sharedService.pageSize[0].size;

    this.getDataSelByAlpha(eve.target.value);
  }


  searchByKeyword(val){
    if(val.length >= 3)
      this.selAllAgency(this.pageCount, this.pageSize, undefined, val, '', this.languageId);
    else if(val == '')
      this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
  }


  getDataSelByAlpha(val){
    let dataUrl="";
    let arrCount1 = [];
      if (val !== "0") {
        this.loading = true;
        if(this.valByAgency == "1"){
          // this.selAgency(this.pageCount, this.pageSize, undefined, val);
          dataUrl = 'agency/agencyid/app?letter='+encodeURIComponent(val)+'&page='+this.pageCount+'&size='+this.pageSize;
          // dataUrl='agency/application/search?letter=' + val +'&agencyId=' + this.valByAgency + '&page=' + this.pageCount + '&size=' + this.pageSize;
        }else if(this.valByAgency == "0"){
          dataUrl = 'agency/application/search/onlineservices?letter=' + encodeURIComponent(val) + '&page=' + this.pageCount + '&size=' + this.pageSize ;
        }
        // return this.sharedService.readPortal(dataUrl, this.pageCount, this.pageSize)
        return this.http.get(this.config.urlPortal + dataUrl + '&language=' + this.languageId)
          .map(res => res.json())
          .subscribe(rData => {
            this.sharedService.errorHandling(rData, (function () {
              this.dataPage = rData;
              if(this.valByAgency == "1"){
                this.dataAgencyPage = rData;
                if (rData['list'].length > 0) {
                  this.seqPageNum = this.dataAgencyPage.pageNumber;
                  this.seqPageSize = this.dataAgencyPage.pageSize;
                  this.noNextData = this.dataAgencyPage.pageNumber === this.dataAgencyPage.totalPages;
                  this.datatblAgencyPage = rData['list'];
                  this.showNoData = false;
                } else {
                  this.showNoData = true;
                  this.seqPageNum = this.dataAgencyPage.pageNumber;
                  this.seqPageSize = this.dataAgencyPage.pageSize;
                  this.noNextData = this.dataAgencyPage.pageNumber === this.dataAgencyPage.totalPages;
                }
              }else{
                if (rData['list'].length > 0) {
                  this.seqPageNum = this.dataPage.pageNumber;
                  this.seqPageSize = this.dataPage.pageSize;
                  this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
                  this.datatblAgency = rData['list'];
                  this.showNoData = false;
                } else {
                  this.showNoData = true;
                  this.seqPageNum = this.dataPage.pageNumber;
                  this.seqPageSize = this.dataPage.pageSize;
                  this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
                }
              }

              console.log(this.dataAgencyPage);
              if(this.dataAgencyPage.list.length != 0) {

                this.dataAgencyPage.list.forEach(el => {
                  // console.log(el.agencyApplications.length)
                  arrCount1.push(el.agencyApplications.length);
                });
              }
              this.totalApps = arrCount1.reduce((a, b) => a + b, 0);
              // console.log(this.totalApps);

            }).bind(this));
            this.loading = false;
          },
            error => {
              this.loading = false;
              this.totalApps = 0;
              this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
            });
      } else {
        if(this.valByAgency !== "0"){
          this.selAgency(this.pageCount, this.pageSize);
        }else{
          this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
        }
      }
  }

  selAllAgency(page, pagesize, isDocument?, keyword?, letter?, lng?) {
    
    this.loading = true;
    let dataUrl = '';
    if(letter && (typeof isDocument !== 'undefined')){
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&letter='+letter+'&document='+isDocument+'&language='+lng;
    }else if(keyword && (typeof isDocument !== 'undefined')){
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&keyword='+keyword+'&document='+isDocument+'&language='+lng;
    }else if(keyword){
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&keyword='+keyword+'&language='+lng;
    }else if(letter){
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&letter='+letter+'&language='+lng;
    }else if(typeof isDocument !== 'undefined'){
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&document='+isDocument+'&language='+lng;
    }else{
      dataUrl = 'agency/application/search/onlineservices?page='+page+'&size='+pagesize+'&language='+lng;
    }

    // return this.sharedService.readPortal('agency/application/search/onlineservices', page, pagesize)
    return this.http.get(this.config.urlPortal+dataUrl)
      .map(res => res.json())
      .subscribe(rData => {
        this.sharedService.errorHandling(rData, (function () {
          this.dataPage = rData;
          if (rData['list'].length > 0) {
            
            this.seqPageNum = this.dataPage.pageNumber;
            this.seqPageSize = this.dataPage.pageSize;
            this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
            this.datatblAgency = rData['list'];
            this.showNoData = false;
            window.scrollTo(0, 0);
          } else {
            this.showNoData = true;
            this.seqPageNum = this.dataPage.pageNumber;
            this.seqPageSize = this.dataPage.pageSize;
            this.noNextData = true;
            // this.noNextData = this.dataPage.pageNumber === this.dataPage.totalPages;
          }
          window.scrollTo(0, 0);
        }).bind(this));
        
        this.loading = false;
      },
        error => {
          this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
        });
  }

  selAgency(page, pagesize, isDocument?, letter?) {
    let arrCount = [];
    this.loading = true;
    if(typeof isDocument !== 'undefined' && typeof letter !== 'undefined'){
      this.agencyUrl = 'agency/agencyid/app?document='+isDocument+'&letter='+letter+'&page='+page+'&size='+pagesize+'&language='+this.languageId;
    }else if(typeof letter !== 'undefined'){
      this.agencyUrl = 'agency/agencyid/app?letter='+letter+'&page='+page+'&size='+pagesize+'&language='+this.languageId;
    }else if(typeof isDocument !== 'undefined'){
      this.agencyUrl = 'agency/agencyid/app?document='+isDocument+'&page='+page+'&size='+pagesize+'&language='+this.languageId;
    }else{
      this.agencyUrl = 'agency/agencyid/app?page='+page+'&size='+pagesize+'&language='+this.languageId;
    }

    return this.http.get(this.config.urlPortal+this.agencyUrl)
      .map(res => res.json())
      .subscribe(rData => {
        this.sharedService.errorHandling(rData, (function () {
          this.dataAgencyPage = rData;
          if (rData['list'].length > 0) {
            this.seqPageNum = this.dataAgencyPage.pageNumber;
            this.seqPageSize = this.dataAgencyPage.pageSize;
            this.noNextData = this.dataAgencyPage.pageNumber === this.dataAgencyPage.totalPages;
            this.datatblAgencyPage = rData['list'];
            this.showNoData = false;
            window.scrollTo(0, 0);
            
          } else {
            this.showNoData = true;
            this.seqPageNum = this.dataAgencyPage.pageNumber;
            this.seqPageSize = this.dataAgencyPage.pageSize;
            // this.noNextData = this.dataAgencyPage.pageNumber === this.dataAgencyPage.totalPages;
            this.noNextData = true;
          }
          this.dataAgencyPage.list.forEach(el => {
            // console.log(el.agencyApplications.length)
            arrCount.push(el.agencyApplications.length);
          });
          this.totalApps = arrCount.reduce((a, b) => a + b, 0);
          window.scrollTo(0, 0);
        }).bind(this));
        this.loading = false;
      },
        error => {
          this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
          this.totalApps = 0;
        });
  }

  reset() {
    this.onlyAgency = false;
    this.chkDownload = false;
    this.chkOnline = false;
    this.keyword = false;
    this.valByAlpha = "0";
    this.valByAgency = "0";
    this.pageCount = 1;
    this.pageSize = 10;
    this.noPrevData = true;
    this.sharedService.defaultPageSize = this.sharedService.pageSize[0].size;
    this.selAllAgency(this.pageCount, this.pageSize, '', '', '', this.languageId);
    this.loadAlpha(true);
  }

  getChkDocData(val){
    this.loading = true;
    if(this.valByAgency == "0"){
      this.selAllAgency(this.pageCount, this.pageSize, val, '', '', this.languageId)
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/onlineservice/onlineservice.component.ts